export default __webpack_public_path__ + "static/media/Spinner.ed3df45f.gif";